// extracted by mini-css-extract-plugin
export default {"background":"About_background__L9CmB","image":"About_image__KZhWN"};